import { useEffect, useState } from 'react';
import _ from 'underscore';
import api from './api';
import sources from './sources';
import useGym from './use_gym';

const useProspectStatuses = (): any[] => {
  const gym = useGym();
  const [statuses, setStatuses] = useState<any[]>([]);

  useEffect(() => {
    const url = sources.forms(gym.id);
    api.get(url, { contact_type: 'prospects' }).then((response) => {
      const contactInfromationForm = _.find(response, { name: 'contact_information' });
      const prospectStatusField = _.find(contactInfromationForm.fields, {
        name: 'prospect_status',
      });

      const prospectStatuses = prospectStatusField.params.options
        .filter((item) => item)
        .map((item) => ({ label: item, value: item }));

      setStatuses(prospectStatuses);
    });
  }, [gym.id]);

  return statuses;
};

export default useProspectStatuses;
